import React, { useContext, useEffect } from "react";

import { Button } from "@/components/common/button";
import { Icon, IconSizeEnum, IconTypeEnum } from "@/components/common/icon";
import Modal from "@/components/common/modal";
import { WebsiteSectionUrl } from "@/components/constants";
import UserContext from "@/contexts/User/UserContext";
import MarketingUtils from "@/marketing/marketingUtils";

import { VideoSessionErrorModalProps } from "./types";
import "./styles.scss";

const VideoSessionErrorModal = ({ urlParamKey }: VideoSessionErrorModalProps) => {
  const { userID } = useContext(UserContext);
  const buttonClickHandler = () => {
    // Used window.location.replace() instead of navigate() because Voxmplant needs resetting.
    // It's similar to window.location.reload() on review page
    window.location.replace(`/${WebsiteSectionUrl.Catalog}`);
  };

  useEffect(
    () =>
      MarketingUtils.reachYandexMetricsGoal("VideoSessionErrorModal", userID),
    [userID],
  );

  return (
    <Modal
      urlParamKey={urlParamKey}
      header=""
      subtitle=""
      isCloseForbidden
    >
      <div className="video-session-error-modal">
        {/* todo: replace with CircleIcon after https://app.weeek.net/ws/668324/task/3005 */}
        <div className="video-session-error-modal__circle-icon red">
          <Icon type={IconTypeEnum.Exclamation} size={IconSizeEnum.Size28} />
        </div>
        <span className="video-session-error-modal__title">Не удалось подключиться к&nbsp;эксперту</span>
        <span className="video-session-error-modal__description">
          Такое случается. Но карты и&nbsp;эксперты по&#8209;прежнему рядом, чтобы помочь вам.
        </span>
        <span className="video-session-error-modal__description">
          Вернитесь в каталог и начните консультацию заново.
        </span>
        <Button
          text="Вернуться в каталог"
          onClick={buttonClickHandler}
        />
      </div>
    </Modal>
  );
};

export default VideoSessionErrorModal;
